import { Chance, UIUtil } from '@suntex.core/animation';
import { $Color, type Color } from '@suntex.core/color';
import { LogLevel, loggedContext } from '@suntex.core/logging';

import { VIF_ADD_SUB_DATA } from './data/vifAddSubData';
import type { BoardGeometry } from './engine/BoardGeometry';
import { ADD_SUB_GEOMETRY } from './engine/BoardGeometry';
import { addSubPatternTable, buildProblemSet } from './engine/ProblemSource';
import { BlockBoardEngine } from './engine/blockBoardEngine';
import type { VifGameProgArgs } from './types';

const ADD = 1;

@loggedContext({ level: LogLevel.Trace, autoLog: true })
class VIFAddSubGame extends BlockBoardEngine {
  private randomPatterns = -1;

  constructor(args: VifGameProgArgs) {
    super(args, 5.0);
  }

  protected get correctColor(): Color {
    return $Color.from('#000000');
  }

  protected get hoverAlpha(): number {
    return 0.7;
  }

  protected get geometry(): BoardGeometry {
    return ADD_SUB_GEOMETRY;
  }

  protected computeStartSeconds(): number[] {
    return [0, 70, 60, 50];
  }

  protected onSetupGame(): void {
    UIUtil.setFrame(this.gameStage.opBtn1, this.gameFlag);
    UIUtil.setFrame(this.gameStage.gameMeter, 3 + this.gameFrame.game);
    UIUtil.setFrame(this.gameStage.roundMeter, 3 + this.gameFrame.round);
  }

  protected populateProblem(): void {
    const intLayer = this.intLayer;
    const tree =
      this.gameFlag == ADD ? VIF_ADD_SUB_DATA.add : VIF_ADD_SUB_DATA.sub;

    let ref;
    if (intLayer == 1) {
      ref = tree.layer1;
    } else {
      if (intLayer == 2 && this.randomPatterns == -1) {
        this.randomPatterns = Chance.randomInt(0, 5);
      }
      ref = addSubPatternTable(tree, intLayer, this.randomPatterns);
    }

    const { topEQs, bottomAnswers } = buildProblemSet({ kind: 'table', ref });
    this.topEQs = topEQs;
    this.bottomAnswers = bottomAnswers;
  }

  protected finalizeNextProblem(): void {
    UIUtil.setFrame(this.gameStage.roundMeter, this.gameFrame.round + 3);
    UIUtil.setFrame(this.gameStage.gameMeter, 3 + this.intLayer);
    this.board.enabled = true;
  }

  protected onWinBeforeGameOver(): void {
    UIUtil.setFrame(this.gameStage.gameMeter, 3 + this.gameFrame.game);
    UIUtil.setFrame(this.gameStage.roundMeter, 3 + this.gameFrame.round);
  }

  protected onRunAnimationMeterUpdate(): void {
    UIUtil.setFrame(this.gameStage.gameMeter, 3 + this.gameFrame.game);
    UIUtil.setFrame(this.gameStage.roundMeter, 3 + this.gameFrame.round);
  }
}

export function VIFAddSub_prog(args: VifGameProgArgs): void {
  new VIFAddSubGame(args).run();
}
